<template>
  <div v-loading="loading" class="pf-typomatch-container">
    <div class="pf-typomatch-text-container">
      <div class="pf-typomatch-text-container--inner">
        {{ $t('portfoliosSelector.matchtypo-text') }}
        <div class="pf-typomatch-btns">
          <button class="brains-type1-btn mr-1" @click="continuevalidation()">{{ $t("validate") }}</button>
        </div>
      </div>
    </div>
    <div class="pf-typomatch-table">
      <div class="pf-typomatch-table-row pf-typomatch-table-title">
        <div class="pf-typomatch-table-row--col1">{{ $t('portfoliosSelector.uploadedTypos') }}</div>
        <div class="pf-typomatch-table-row--col2">{{ $t('portfoliosSelector.matchingBrainsreTypos') }}</div>
      </div>
      <div v-for="item in possibleTypos" :key="item" class="pf-typomatch-table-row">
        <div class="pf-typomatch-table-row--col1">{{ item }}</div>
        <div class="pf-typomatch-table-row--col2">
          <brainsSelector ref="typoselectors" :datalist="brainsTypos" :selected-property="getSelectedProp(item)" @input="addNewTypoMatch(item, ...arguments)" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import brainsSelector from '@/components/designComponents/brainsSelector'
// import { setportfoliovalidation } from '@/api/portfoliouser'
export default {
  components: { brainsSelector },
  props: {
    portfolioname: {
      required: true,
      type: Number
    },
    matchdata: {
      required: true,
      type: Array
    },
    possibleTypos: {
      required: true,
      type: Array
    }
  },
  data() {
    return {
      loading: false,
      typoMatch: [],
      brainsTypos: ['Residential', 'Office', 'Retail', 'Industrial']
    }
  },
  methods: {
    getSelectedProp(clientTypo) {
      switch (clientTypo.toLowerCase()) {
        case 'residential':
        case 'flat':
        case 'house':
          this.addNewTypoMatch(clientTypo, 'Residential')
          return 'Residential'
        case 'office':
          this.addNewTypoMatch(clientTypo, 'Office')
          return 'Office'
        case 'industrial':
          this.addNewTypoMatch(clientTypo, 'Industrial')
          return 'Industrial'
        case 'retail':
          this.addNewTypoMatch(clientTypo, 'Retail')
          return 'Retail'
        default:
          return ''
      }
    },
    addNewTypoMatch(clientTypo, brainsTypo) {
      var vm = this
      if (brainsTypo === null || brainsTypo === undefined || brainsTypo === '') {
        vm.typoMatch = vm.typoMatch.filter(function(item) { return item.clientTypo !== clientTypo })
      } else if (this.typoMatch.some(s => s.clientTypo === clientTypo)) {
        var match = this.typoMatch.filter(item => item.clientTypo === clientTypo)[0]
        match.brainsTypo = brainsTypo
        console.log(this.typoMatch)
      } else {
        this.typoMatch.push({
          clientTypo: clientTypo,
          brainsTypo: brainsTypo
        })
      }
    },
    continuevalidation() {
      var vm = this
      vm.loading = true
      var columnsmatchs = {
        id: vm.portfolioname,
        columns: vm.matchdata,
        typos: vm.typoMatch
      }
      vm.$refs.typoselectors.forEach((item, index) => {
        if (item.inputModel !== '') {
          vm.addNewTypoMatch(vm.possibleTypos[index], item.inputModel)
        }
      })
      vm.$store.dispatch('portfolio/setportfoliovalidation', columnsmatchs)
        .then((response) => {
          console.log(response)
          vm.loading = false
        })
        .catch(() => {
          vm.activatebuttons(true)
          vm.$message({
            showClose: true,
            message: this.$t('portfoliosSelector.errorgettingexcel'),
            type: 'error'
          })
          vm.loading = false
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.pf-typomatch-text-container {
  font-size: 13px;
  margin-bottom: 20px;
  display: flex;
  justify-content: center;

  &--inner {
    display: flex;
    justify-content: center;
    max-width: 550px;
    padding: 10px;
    border-bottom: 1px solid lightgrey;
  }
}

.pf-typomatch-btns {
  height: 32px;
  margin-left: 50px;
}

.pf-typomatch-container {
  height: 100%;
  width: 100%;
  text-align: center;
  position: relative;

  .pf-typomatch-table {
    height: 100%;
    width: 500px;
    margin: 0 auto;

    .pf-typomatch-table-title {
      border-bottom: 2px solid #1e3cff;
      font-family: 'Montserrat-SemiBold',sans-serif;
      font-size: 15px;
    }

    .pf-typomatch-table-row {
      display: grid;
      grid-template-columns: 1fr 1fr;
      font-size: 14px;

      &--col1 {
        display: flex;
        border-right: 1px solid lightgrey;
        padding: 5px;
        align-items: center;
        justify-content: center;
      }

      &--col2 {
        display: flex;
        padding: 5px;
        justify-content: center;
      }
    }

  }
}
</style>
<style>
.brainsSelector-selected {
  background-color: #009999 !important;
  color: white !important;
}
</style>
